import styled from 'styled-components';

export const Label = styled.label<{ $disabled: boolean }>`
  ${({ $disabled }) => !$disabled && 'cursor: pointer;'}
`;

export const HiddenInput = styled.input`
  display: none;
`;
